//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		data() {
			return {
				listData: [],
				total:1,
				sortIndex:0,
				isApp:'',
				isAndroid:'',
        searchShow:false,   //触发搜索
        searchShowIcon:false,
        searchBack:false,   //触发返回
        searchText:'',      //搜索内容
        searchContent:[],   //搜索历史
        filtrateItem:[
          {text:'进行中',light:true,up:true},
          {text:'按领域',light:false,up:false},
          {text:'按区域',light:false,up:false}
          ],
        filtKey:3,    //筛选项选择（默认无）
        filtIcon:{
          downed:require('../assets/images/downedicon@2x.png'), //默认
          down:require('../assets/images/downicon@2x.png'),   //选择下
          up:require('../assets/images/upicon@2x.png')      //选中上
        },
        filtShow:false,     //筛选层
        filtrateItemStatus:[
          {
              text:'全部',
              code:''
          },{
              text:'进行中',
              code:4,
          },{
              text:'执行中',
              code:5,
          },{
              text:'已结束',
              code:6,
          }
        ],    //状态筛选
        filtKeyStatus:1,   //默认进行中
        filtrateItemStatusCode:4,
        filtrateItemField:[
          {
              text:'全部',
              code:'',
          },{
              text:'教育资助',
              code:2,
          },{
              text:'医疗救助',
              code:3,
          },{
              text:'创业帮扶',
              code:4,
          },{
              text:'其他项目',
              code:999,
          }
        ],  //领域筛选
        filtKeyField:0,    //默认全部
        filtrateItemFieldCode:'',
        filtrateItemArea:[],     //区域筛选
        filtrateItemAreaCode:'',  //区域code码
        filtKeyArea:100,     //默认全部
        filtAreaShow:false,  //区域显示
        isProvince:this.$route.query.isProvince,
        filtrateItemAreaAllCode:'',
        
			}
		},
		filters: {
			moneyFilter (value) {
				let transformValue
				if(value >= 10000) {
					transformValue = (value/10000).toFixed(3).slice(0,-1)
				}
				return value >= 10000 ? transformValue +'万' : value
			}
		},
		methods: {
			wxchat () {
		        let self = this;
		        this.$https.get(this.BASE_URL+'uts/invitationCode/wxAuthorization',{params:{
		              'code':this.getUrlParamURLysas("code")
		            }}).then( data => {
         			let res = data.data
		            if(res.code == 'UTSI0000') {
		            	self.zcuserid = res.data.userId;
                  self.zctoken = res.data.logintoken;
			            self.zcnickname = res.data.nickname
			            localStorage.setItem('zcuserid',res.data.userId);
			            localStorage.setItem('zcopenid',res.data.openid);
			            localStorage.setItem('zcunionid',res.data.unionid);
			            localStorage.setItem('zcnickname',res.data.nickname);
			            localStorage.setItem('zcheadimgurl',res.data.headimgurl);
			            localStorage.setItem('zctoken',self.zctoken);
		            }
		        })
		 	},
			isAuthorization() {
				window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.wechatAppid + "&redirect_uri=" + encodeURIComponent( this.appjump_url + "/pages/index/#/poverty/null/null/null?isSingle=single")+"&scope=snsapi_userinfo&response_type=code&state=wxh5267689457315#wechat_redirect"
		   	},
		   	getUrlParamURLysas(name) {
			    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
			    var r = window.location.search.substr(1).match(reg);
			    if (r != null){
			        return unescape(r[2]);
			    }
			    return "";
			},
			goHome() {
                // window.myhome.windowfinish();
        var u = navigator.userAgent
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if(isiOS){
          console.log('原生ios返回~~~~')
             window.webkit.messageHandlers.PopVCApp.postMessage('')
        }else{
          console.log('原生安卓返回~~~~')
            javascript: android.PopToApp('')
        }
			},
			goBack() {
                window.location.href="../../index.html"
                // window.history.back(-1)
			},
			goQKL (data) {
				if(this.isWeixinCient()){
					window.location.href=this.QKL_URL+data
				}else{
					window.navigation.pushPage('{"title":"扶贫区块链","url":"'+this.QKL_URL+data+'&&platform=app","navbarHidden":"YES"}')
				}
			},
			getList(done) {
        this.total = 1
        this.sortIndex = 0
				// 获取列表数据
				let data = {
					acr010: "",
					acr012: "",
					pageIndex: this.sortIndex,
					pageSize: 1000000,
					xmpx: 1,
          acr018:this.filtrateItemStatusCode,  //状态
          acr010:this.filtrateItemFieldCode,  //项目领域
          azc001:this.filtrateItemAreaCode,  //区划 省
          query:this.searchText,   //搜索内容
				}
				this.$https.post(this.BASE_URL+"cfs/zc/project/getdfzhongchouList",data).then(res => {
					if(res.data.data == null){
						this.total = 0
					}else{
						this.total = res.data.data.total
					}
					this.listData = [...this.listData,...res.data.data.data]      //es6用
          if(done){
		         		done(true)
		         	}
				})
				.catch(res => {

				})
			},
			goDetail(acr001) {
				// 详情跳转
				if(this.isWeixinCient()) {
					if(this.$route.query.isSingle == "single") {
						this.$router.push('/zcprojectDetail/'+acr001+'/'+localStorage.getItem("zcuserid")+'/'+encodeURIComponent(localStorage.getItem("zcnickname"))+'/'+localStorage.getItem("zctoken"))

					}else {
						this.$router.push('/zcprojectDetail/'+acr001+'/'+this.$route.params.userid+'/'+encodeURIComponent(this.$route.params.nickname)+'/'+this.$route.params.token)
					}
				}else {
					// app跳转
					this.$router.push('/zcprojectDetail/'+acr001+'/'+this.$route.params.userid+'/'+encodeURIComponent(this.$route.params.nickname)+'/'+this.$route.params.token+'?headImage='+this.$route.query.headImage)
				}
			},
			refresh (done) {
			  	setTimeout(() => {
			  		this.sortIndex = 0
            this.listData = {}
            this.getList();
            done()
			  	}, 1000)
			},
		 	infinite (done) {
		 		setTimeout(() => {
//			   		if(this.listData.length < this.total) {
//			   			this.sortIndex++
//			 			  this.getList(done);
//			   		}else {
			   			done(true)
//			   		}
		 		}, 10000)
		 	},
      getfiltrateItem(key){
        //筛选条件
        let _this=this
        this.filtKey = key;
        this.filtShow = true;
        this.filtrateItem[key].light = true;
        this.filtrateItem[key].up = false;
        if(key == 2){
          if(this.$route.query.provinceCode){
            this.filtrateItem[key].light = false;
            this.filtrateItem[key].up = false;
            this.filtShow = false;
            if(localStorage.getItem('isCooperation') == 1 || localStorage.getItem('isCooperation') == '1'){
              _this.filtAreaShow = true;
            }else{
              this.filtKey = 100;
              _this.filtAreaShow = false;
            }
          }else{
            this.filtAreaShow = true;
          }
        }
      },
      getfiltrateItemSFA(key){
        //状态筛选
        console.log(key,this.filtKey)

        if(this.filtKey == 0){
          this.filtKeyStatus = key;
          this.filtrateItem[0].text = this.filtrateItemStatus[key].text;
          this.filtrateItemStatusCode = this.filtrateItemStatus[key].code;
          this.filtrateItem[0].up = true;
        }else if(this.filtKey == 1){
          this.filtKeyField = key;
          this.filtrateItem[1].text = this.filtrateItemField[key].text;
          this.filtrateItemFieldCode = this.filtrateItemField[key].code;
          this.filtrateItem[1].up = true;
        }else if(this.filtKey == 2){
            if(key == 100){
              this.filtrateItem[2].text = '全部';
              if(localStorage.getItem('isCooperation') != 1 || localStorage.getItem('isCooperation') != 1){
                this.filtrateItemAreaCode = '';
              }else{
                this.filtrateItemAreaCode = this.filtrateItemAreaAllCode
              }
            }else{
              this.filtrateItem[2].text = this.filtrateItemArea[key].aar009;
              this.filtrateItemAreaCode = this.filtrateItemArea[key].aar001;
            }
            this.filtKeyArea = key;
            this.filtAreaShow = false;
            this.filtrateItem[2].up = true;
            this.filtrateItem[2].light = true
        }
        this.filtShow = false;
        this.filtAreaShow = false;

        //筛选
        this.sortIndex = 0;
        this.listData = {};
        this.getList();
      },
      areaBack(){
          //区域关闭
        this.filtShow = false;
        this.filtAreaShow = false;
        if(this.filtKeyArea == 100){
            this.filtrateItem[2].text = '全部';
        }
        this.filtrateItem[2].up = true;
        this.filtrateItem[2].light = true
      },
      povertySearch(){
          //触发搜索
        this.searchShow = true;
        this.searchBack = true;
        if(this.searchText != ''){
          this.searchShowIcon = true;
        }else {
          this.searchShowIcon = false;
        }
      },
      nowInput(e){
        if(e.target.value == ''){
          this.searchShowIcon = false;
        }else {
          this.searchShowIcon = true;
        }
      },
      closeIcon(){
        this.searchText = '';
        this.searchShowIcon = false;
      },
      inputSearch(){
        this.searchContent = JSON.parse(window.localStorage.getItem('searchContent'));
        //键盘事件
        if(this.searchText != ''){
            this.searchShowIcon = true;
            var addCont = [];
            if(this.searchContent != null){
              addCont = this.searchContent;
            }
            addCont.unshift(this.searchText.trim());
            this.searchContent = addCont;
            if(this.searchContent.length>1){
              var searchTemp = [];
              for(var i=0;i<this.searchContent.length;i++){
                if(searchTemp.indexOf(this.searchContent[i])==-1){
                  searchTemp.push(this.searchContent[i])
                }
              }
              this.searchContent = searchTemp
            }
            window.localStorage.setItem('searchContent',JSON.stringify(this.searchContent));
        }else{
          this.searchShowIcon = false;
        }
        this.$refs.inputKeyUP.blur();
        this.searchShow = false;
        this.searchBack = false;
        //搜索
        this.sortIndex = 0;
        this.listData = {};
        this.getList();
        //搜索子页
        this.$router.push({
          path:'/povertySearch/'+this.$route.params.userid+'/'+encodeURIComponent(this.$route.params.nickname)+'/'+this.$route.params.token,
          query:{
            searchText:this.searchText,
            statusCode:this.filtrateItemStatusCode,
            fieldCode:this.filtrateItem[1].text,
            areaCode:this.filtrateItemAreaCode,
            areaName:this.filtrateItem[2].text,
            filtKeyArea:this.filtKeyArea
          }
        })
      },
      fillSearchText(cont){
        //历史记录填入搜索框并搜索
        this.searchText = cont;
        this.inputSearch();
        //搜索子页
        this.$router.push({
          path:'/povertySearch/'+this.$route.params.userid+'/'+encodeURIComponent(this.$route.params.nickname)+'/'+this.$route.params.token,
          query:{
            searchText:this.searchText,
            statusCode:this.filtrateItemStatusCode,
            fieldCode:this.filtrateItem[1].text,
            areaCode:this.filtrateItemAreaCode,
            areaName:this.filtrateItem[2].text,
            filtKeyArea:this.filtKeyArea
          }
        })      },
      deleteHistory(){
        //清空历史
        this.searchContent = [];
        window.localStorage.setItem('searchContent',JSON.stringify(this.searchContent));
      },
      backOBJ(){
        console.log('1111111111')
          //返回对应位置
        if(this.searchBack == true){
            //返回列表
            this.searchShow = false;
            this.searchShowIcon = false;
            this.searchText = '';
            this.searchBack = false;
            //返回列表
            this.searchText = '';
            this.sortIndex = 0;
            this.listData = {}
            this.getList();
        }else{
          if(this.isWeixinCient()){
            //微信返回
            this.goBack();
          }else{
            this.goHome();
          }
        }
      },
      getDistrict(){
          //获取区划地址
        var data = {
          aar002:100
        }
        this.$jsonp(this.wechat_url+'/shfp/ajaxquery/mall/index/queryReagionCode',data).then(
            res => {
                this.filtrateItemArea = res.result.data;
            }
        ).catch(
            err => {
                 console.log(err)
            }
        )
      },
      getCooperationList(){
        var data = {
          regionId: this.filtrateItemAreaCode
        }
        this.$https.get(this.BASE_URL+'hts/area/getWestProByEast',{params:data}).then(
            res => {
              this.filtrateItemArea = res.data.data;
              let arrCode =[]
              this.filtrateItemArea.forEach(function(value,index,array){
                arrCode.push(value.aar001)
              })
              this.filtrateItemAreaAllCode = arrCode.toString()
              this.filtrateItemAreaCode = arrCode.toString()
              this.getList()

            }
        ).catch(
            err => {
                 console.log(err)
            }
        )
      }
		},
		created() {
      // 判断是否为东西部协作
      console.log(this.$route)
      let _this= this
      if(this.$route.query.cooperation == 1 || this.$route.query.cooperation == '1'){
        localStorage.setItem('isCooperation',this.$route.query.cooperation)
      }
      if(localStorage.getItem('isCooperation') == 1 || localStorage.getItem('isCooperation') =='1'){
        this.filtrateItemAreaCode = this.$route.query.provinceCode
        localStorage.setItem('eastProvince',this.filtrateItemAreaCode)
        this.getCooperationList()
      }else{
        this.getDistrict();
      }
      localStorage.setItem('isProvince',this.isProvince)
      this.searchContent = JSON.parse(window.localStorage.getItem('searchContent'));
      if(this.$route.query.fieldCode != undefined){
        //搜索、筛选内容
        this.filtrateItemStatusCode = this.$route.query.statusCode;
        if(this.filtrateItemStatusCode == 4){
          this.filtrateItem[0].text = this.filtrateItemStatus[1].text;
        }else if(this.filtrateItemStatusCode == 5){
          this.filtrateItem[0].text = this.filtrateItemStatus[2].text;
        }else if(this.filtrateItemStatusCode == 6){
          this.filtrateItem[0].text = this.filtrateItemStatus[3].text;
        }else{
          this.filtrateItem[0].text = this.filtrateItemStatus[0].text;
        }
        this.filtrateItem[1].text = this.$route.query.fieldCode;
        if(this.$route.query.fieldCode == '教育资助'){
          this.filtrateItemFieldCode = 2
          this.filtrateItem[1].light = true;
          this.filtrateItem[1].up = true;
        }else if(this.$route.query.fieldCode == '医疗救助'){
          this.filtrateItemFieldCode = 3
          this.filtrateItem[1].light = true;
          this.filtrateItem[1].up = true;
        }else if(this.$route.query.fieldCode == '创业帮扶'){
          this.filtrateItemFieldCode = 4
          this.filtrateItem[1].light = true;
          this.filtrateItem[1].up = true;
        }else if(this.$route.query.fieldCode == '其他项目'){
          this.filtrateItemFieldCode = 999
          this.filtrateItem[1].light = true;
          this.filtrateItem[1].up = true;
        }else if(this.$route.query.fieldCode == '全部'){
          this.filtrateItemFieldCode = ''
          this.filtrateItem[1].light = true;
          this.filtrateItem[1].up = true;
        }else{
          this.filtrateItemFieldCode = ''
        }
        this.filtrateItemAreaCode = this.$route.query.areaCode;
        this.filtrateItem[2].text = this.$route.query.areaName;
        this.filtKeyArea = this.$route.query.filtKeyArea;
        if(this.$route.query.areaName != '按区域'){
          this.filtrateItem[2].light = true;
          this.filtrateItem[2].up = true;
        }
      }

      // isApp=1 显示app头部
			this.isApp = this.$route.query.isApp
			let u = navigator.userAgent
      this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
      // 判断是不是从链接进来的
      if(this.isWeixinCient()) {
        if(this.$route.query.isSingle == "single") {
          // 从链接进去，需要页面授权
          if(this.getUrlParamURLysas("code") == null || this.getUrlParamURLysas("code") ==''){
          this.isAuthorization()
        }else {
          this.wxchat()
        }
        }
      }else {
        console.log('扶贫众筹列表::::'+this.$route.params.token)
      }
      if(this.$route.query.provinceCode) {
        if(localStorage.getItem('isCooperation') != 1 || localStorage.getItem('isCooperation') != '1'){
          this.filtrateItemAreaCode = _this.$route.query.provinceCode
          this.filtrateItem[2].text = _this.$route.query.provinceName
        }else{
          this.filtAreaShow = false
          this.filtrateItem[2].text =  '全部'
        }
      }
      if(localStorage.getItem('isCooperation') != 1 || localStorage.getItem('isCooperation') !='1'){
        this.getList()
      }
		}
	}



// WEBPACK FOOTER //
// ./src/crowd_fund/povertyAlleviation.vue